var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Portal", [
    _c(
      "div",
      {
        ref: _vm.idMenu,
        class: [
          "sideMenu " + _vm.classes,
          _vm.idMenu,
          { collapsed: _vm.isCollapsed },
        ],
        style: { width: `${_vm.width}px` },
        on: { mouseleave: _vm.onLeave },
      },
      [
        _c(
          "a",
          {
            staticClass: "btn-toggleSidebar",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.onToggleSidebar.apply(null, arguments)
              },
            },
          },
          [_c("Icon", { attrs: { name: "Menu" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "inner", staticStyle: { overflow: "hidden" } },
          [
            _vm.enableResize
              ? [
                  _c("div", {
                    ref: `resizer.${_vm.idMenu}`,
                    staticClass: "resizer",
                    on: { mousedown: _vm.onResizerDown },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._t("back"),
            _vm._v(" "),
            _vm.enableShow
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "button is-sidebar",
                      on: { click: _vm.onPin },
                    },
                    [
                      _c(
                        "span",
                        [
                          _vm.isPinned
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "icon" },
                                  [_c("Icon", { attrs: { name: "UnPin" } })],
                                  1
                                ),
                              ]
                            : !_vm.$slots.trigger
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "icon" },
                                  [_c("Icon", { attrs: { name: "Pin" } })],
                                  1
                                ),
                              ]
                            : [_vm._t("trigger")],
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-1", on: { mouseover: _vm.onOver } },
              [_vm._t("default")],
              2
            ),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _vm.showOverlay
      ? _c("div", {
          staticClass: "sideMenu-Overlay",
          on: { click: _vm.collapseMenu },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }